import { createSlice } from '@reduxjs/toolkit';
import { callApi } from '../../utils/apiCall';
import { updateError } from './user';
import { dispatch } from '../store';

const initialState = {
    spamLeads: {
        results: [],
        count: 0,
    },
    isLoading: false,
};

const slice = createSlice({
    name: 'spamLeads',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.isLoading = action.payload;
        },
        updateSpamLeads(state, action) {
            state.spamLeads.results = action.payload.results;
            state.spamLeads.count = action.payload.count;
        },
    },
});

export default slice.reducer;

export function getSpamLeads({ practiceId, searchQuery, limit = 25, offset = 0 }, handleComplete) {
    return async () => {
        try {
            dispatch(slice.actions.setLoading(true));
            const query = `limit=${limit}&offset=${offset}&ordering=-updated_at`;
            const search = searchQuery && searchQuery.length > 0 ? `?query=${searchQuery}&${query}` : `?${query}`;
            const response = await callApi(`/api/v1/practices/${practiceId}/leads/spam/${search}`);
            if (response.status === 200) {
                dispatch(slice.actions.updateSpamLeads(response.data));
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data) || 'Something went wrong', success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
        } finally {
            dispatch(slice.actions.setLoading(false));
            if (handleComplete) handleComplete();
        }
    };
}

export function markAsSpam({ practiceId, leadId, handleClose }) {
    return async () => {
        try {
            const response = await callApi(
                `/api/v1/practices/${practiceId}/leads/${leadId}/mark_as_spam/`, 'post'
            );
            if (response.status === 200) {
                dispatch(updateError({ message: 'Lead successfully marked as spam', success: true }));
                if (handleClose) handleClose('finish');
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data) || 'Something went wrong', success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
        }
    };
}

export function unmarkAsSpam({ practiceId, leadId, handleClose }) {
    return async () => {
        try {
            const response = await callApi(
                `/api/v1/practices/${practiceId}/leads/${leadId}/unmark_as_spam/`, 'post'
            );
            if (response.status === 200) {
                dispatch(updateError({ message: 'Lead successfully restored from spam', success: true }));
                if (handleClose) handleClose('finish');
            } else {
                dispatch(updateError({ message: JSON.stringify(response?.data) || 'Something went wrong', success: false }));
            }
        } catch (error) {
            dispatch(updateError({ message: JSON.stringify(error.message) || 'Something went wrong', success: false }));
        }
    };
}
